import { render, staticRenderFns } from "./MarginBenefit.vue?vue&type=template&id=77194748&scoped=true&"
import script from "./MarginBenefit.vue?vue&type=script&lang=js&"
export * from "./MarginBenefit.vue?vue&type=script&lang=js&"
import style0 from "./MarginBenefit.vue?vue&type=style&index=0&id=77194748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77194748",
  null
  
)

export default component.exports